import api from "../_app/api";
import { Feature } from "./types";

export const getEnabledFeatures = async () => {
  const data: Feature[] = [];
  const results = await Promise.allSettled([
    api({
      method: "GET",
      url: "/features",
    }),
    api({
      method: "GET",
      url: "/development-features/my",
    }),
  ]);
  for (const result of results) {
    if (result.status === "fulfilled") {
      data.push(...result.value.data);
    } else {
      throw new Error(`Error fetching features: ${result.reason}`);
    }
  }
  return data;
};
